{
  "mobileNavigationMenu": "Menu",
  "companyInformation": "Company information",
  "users": "Users",
  "userGroups": "User groups",
  "orders": "Orders",
  "devices": "Devices"
}
